import LinkExternalIcon from "@atlaskit/icon/core/link-external";
import EditIcon from "@atlaskit/icon/core/edit";
import EyeOpenIcon from "@atlaskit/icon/core/eye-open";
import AddIcon from "@atlaskit/icon/core/add";
import CommentIcon from "@atlaskit/icon/core/comment";
import OnCallIcon from "@atlaskit/icon/core/on-call";
import RoadmapIcon from "@atlaskit/icon/core/roadmap";
import ArchiveIcon from "@atlaskit/icon/core/archive-box";
import {token} from "@atlaskit/tokens";
import type {ReactNode} from "react";
import {ScheduleCallIcon} from "~/components/svgs";
import type {
    TableRowActionsConfig,
    TableRowActionsMenuItem,
    TableRowActionsMenuItemDefinition,
} from "~/components/table/tableRowActions.types";

export const TABLE_ROW_ACTIONS_MENU_ITEMS: Record<
    TableRowActionsMenuItem,
    TableRowActionsMenuItemDefinition
> = {
    profile: {id: "profile", label: "profile", icon: <LinkExternalIcon label="" size="small" />},
    disposition: {id: "disposition", label: "Dispose", icon: <RoadmapIcon label="" size="small" />},
    edit: {id: "edit", label: "Edit", icon: <EditIcon label="" size="small" />},
    view: {id: "view", label: "View", icon: <EyeOpenIcon label="" size="small" />},
    create: {id: "create", label: "Create", icon: <AddIcon label="" size="small" />},
    logCall: {id: "logCall", label: "Log a call", icon: <OnCallIcon label="" size="small" />},
    notes: {id: "notes", label: "Notes", icon: <CommentIcon label="" size="small" />},
    scheduleCall: {
        id: "scheduleCall",
        label: "Schedule a call",
        icon: <ScheduleCallIcon size={20} />,
    },
    archive: {id: "archive", label: "Archive", icon: <ArchiveIcon label="" size="small" />},
};

/** ScheduleCallIcon uses an explicit fill color; Atlaskit menu icons inherit disabled styling from the parent. */
export function getTableRowActionsMenuItemIcon(
    itemId: TableRowActionsMenuItem,
    isDisabled: boolean,
): ReactNode {
    const item = TABLE_ROW_ACTIONS_MENU_ITEMS[itemId];
    if (itemId === "scheduleCall") {
        return (
            <ScheduleCallIcon
                size={20}
                color={isDisabled === true ? token("color.icon.disabled") : token("color.icon")}
            />
        );
    }
    return item.icon;
}

export function getTableRowActionsMenuHandler<TRow>(
    itemId: TableRowActionsMenuItem,
    config: TableRowActionsConfig<TRow>,
): ((row: TRow) => void) | undefined {
    switch (itemId) {
        case "profile":
            return config.onProfile;
        case "disposition":
            return config.onDisposition;
        case "edit":
            return config.onEdit;
        case "view":
            return config.onView;
        case "create":
            return config.onCreate;
        case "logCall":
            return config.onLogCall;
        case "notes":
            return config.onNotes;
        case "scheduleCall":
            return config.onScheduleCall;
        case "archive":
            return config.onArchive;
        default:
            return undefined;
    }
}
